module.exports = "/images/vendor/leaflet.fullscreen/icon-fullscreen.png?fdda34de614379d4229229cb0cb43799";